import { IMessageService } from "./IMessageService";
import React from "react";
import { Toast } from "react-bootstrap";
import { FaExclamationCircle, FaInfoCircle } from "react-icons/fa";

class InnerHTMLComponent extends React.Component<{content: string}> {
  createMarkup() {
    return {__html: this.props.content};
  }

  render() {
    return <span dangerouslySetInnerHTML={this.createMarkup()} />;
  }
}

export class MessageBoard extends React.Component<{messageService: IMessageService}> {

  componentDidMount() {
    this.props.messageService.subscribe(() => {
      this.forceUpdate();
    });
  }

  getClass(channel: "Info" | "Warn" | "Error") {
    switch (channel) {
      case "Info": return "text-primary";
      case "Warn": return "text-warning";
      case "Error": return "text-danger";
    }
  }

  getIcon(channel: "Info" | "Warn" | "Error") {
    switch (channel) {
      case "Info": return <FaInfoCircle/>;
      case "Warn": return <FaExclamationCircle/>;
      case "Error": return <FaExclamationCircle/>;
    }
  }

  showDate(timestamp: Date) {
    return ((timestamp.toDateString() !== (new Date().toDateString())))
  }

  render() {
    return (<div className="message-board">{
      this.props.messageService.getMessages().map((message, index) =>
        <Toast key={'message-' + index} onClose={() => this.props.messageService.dismissMessage(message)}>
          <Toast.Header className={this.getClass(message.channel)}>
            {this.getIcon(message.channel)}
            &nbsp;
            <strong><InnerHTMLComponent content={message.message}/></strong>
            &nbsp;<small>
            {
              this.showDate(message.timestamp)
              ? message.timestamp.toLocaleDateString()
              : message.timestamp.toLocaleTimeString()
            }</small>
          </Toast.Header>
          <Toast.Body><InnerHTMLComponent content={message.detail}/></Toast.Body>
        </Toast>
      )
    }</div>)}
}
